import axios from './axios'
export default {
  subscription: function(projectId) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/projects/${projectId}/subscription`
    )
  },
  saveTemp: function(projectId, data) {
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/projects/${projectId}/subscribe/save`,
      data
    )
  },
  cancelTemp: function(projectId, data) {
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/projects/${projectId}/subscription/cancel-temp`,
      data
    )
  },
  cancelSubscription: function(projectId) {
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/projects/${projectId}/subscription/cancel`,
      data
    )
  },
  plans: function(projectId) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/projects/${projectId}/plans`
    )
  },
  history: function(projectId) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/projects/${projectId}/subscription/history`
    )
  }
}
